import { FunctionComponent, useState } from 'react';

import Button, { ButtonLayouts, ButtonStyles, ButtonTypes } from 'components/layout/Button';
import Form from 'components/layout/forms/Form';
import Input from 'components/layout/forms/Input';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';
import ReCAPTCHA from 'components/layout/ReCAPTCHA';

import StyledComponent from './styles';
import { Errors, Props } from './types';

const PublicPagePasswordResetForgottenPassword: FunctionComponent<Props> = ({
    actions,
    onSuccess,
    localeData: { headline, paragraph, form },
}) => {
    const [recaptchaToken, setRecaptchaToken]: [string, Function] = useState(null);
    const [errorMessage, setErrorMessage]: [Errors, Function] = useState(null);

    return (
        <StyledComponent
            className="public-page-password-reset-forgotten-password"
        >
            <LayoutContainer
                size={Sizes?.XMedium}
                className="content-container"
            >
                <div
                    className="headline"
                    dangerouslySetInnerHTML={{ __html: headline }}
                />
                <p
                    className="paragraph"
                    dangerouslySetInnerHTML={{ __html: paragraph }}
                />


                <Form
                    submitAction={async (values) => {
                        try {
                            const response = await actions.passwordReset({
                                email: values?.email,
                                recaptchaToken,
                            });
                            return response;
                        }
                        catch (error) {
                            console.error(error);
                            setErrorMessage(error?.payload?.originalError?.data?.errors);
                            throw error;
                        }
                    }}
                    onSuccess={onSuccess}
                >
                    {({ formik }) => (
                        <div className='form-container'>
                            <div className="form-input">
                                <Input
                                    name='email'
                                    label={form?.inputLabel}
                                    placeholder={form?.inputLabel}
                                    onChange={formik.handleChange}
                                    value={formik.values.email}
                                    error={errorMessage?.email}
                                />
                            </div>

                            <div className="google-recaptcha">
                                <ReCAPTCHA
                                    onChange={(token: string) => setRecaptchaToken(token)}
                                    error={errorMessage?.recaptchaToken}
                                />
                            </div>

                            <Button
                                className="submit-button"
                                style={ButtonStyles.Primary}
                                layout={ButtonLayouts.Wide}
                                loading={formik.isSubmitting}
                                type={ButtonTypes.Submit}
                            >
                                {form.buttonLabel}
                            </Button>
                        </div>
                    )}
                </Form>

            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPagePasswordResetForgottenPassword;